'use client'

import dynamic from 'next/dynamic'
import type React from 'react'

import { Content } from '@fukku/dialog/Content'
import { Fullscreen } from '@fukku/dialog/Fullscreen'
import { useAnalytics } from 'pdp/src/contexts/AnalyticsProvider/AnalyticsProvider'
import { PdpActionEvents } from 'pdp/src/types/PdpActionEvents'
import { useZoom } from './contexts/ZoomProvider'

const DynamicZoomContent = dynamic(() =>
	import(
		'pdp/src/components/Gallery/Zoom/components/ZoomContent/ZoomContent'
	).then((mod) => mod.ZoomContent)
)

const DynamicThumbnails = dynamic(() =>
	import(
		'pdp/src/components/Gallery/Zoom/components/Thumbnails/Thumbnails'
	).then((mod) => mod.Thumbnails)
)

import type { Media } from '../../../types/FullProduct'

import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import styles from './Zoom.module.scss'

export function Zoom({ media }: { readonly media: Media[] }): React.ReactNode {
	const { zoomDialogRef } = useZoom()
	const { isLargeOrGreater } = useResponsive()
	const { sendPdpActionEvent } = useAnalytics()

	const closeModal = () => {
		sendPdpActionEvent(PdpActionEvents.ZOOM_CLOSE)
	}

	return (
		<Fullscreen ref={zoomDialogRef} onClose={closeModal} title='Zoom'>
			<Content className={styles.dialogContent} hasPadding={false}>
				<DynamicZoomContent media={media} />
				{isLargeOrGreater && <DynamicThumbnails media={media} />}
			</Content>
		</Fullscreen>
	)
}
